import { render, staticRenderFns } from "./cSocialCharts.vue?vue&type=template&id=2d383b8a&scoped=true&"
import script from "./cSocialCharts.vue?vue&type=script&lang=js&"
export * from "./cSocialCharts.vue?vue&type=script&lang=js&"
import style0 from "./cSocialCharts.vue?vue&type=style&index=0&id=2d383b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d383b8a",
  null
  
)

export default component.exports